import { render, staticRenderFns } from "./UsageQuota.vue?vue&type=template&id=b9e3a3ca&scoped=true&"
import script from "./UsageQuota.vue?vue&type=script&lang=js&"
export * from "./UsageQuota.vue?vue&type=script&lang=js&"
import style0 from "./UsageQuota.vue?vue&type=style&index=0&id=b9e3a3ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e3a3ca",
  null
  
)

export default component.exports